/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var moduleClassNameFactory_1 = require("../util/moduleClassNameFactory");
var AccountSwitch_1 = require("./AccountSwitch");
var objectWithout_1 = require("../util/objectWithout");
// import * as PropTypes from "prop-types";
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-managedAccountSwitch");
var ManagedAccountSwitch = /** @class */ (function (_super) {
    tslib_1.__extends(ManagedAccountSwitch, _super);
    function ManagedAccountSwitch(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (currentActiveState) {
            var newActiveState = !_this.state.active;
            _this.setState({
                active: newActiveState
            }, function () {
                if (_this.props.onClick) {
                    _this.props.onClick(currentActiveState);
                }
            });
        };
        _this.onRequestClose = function () {
            _this.setState({
                active: false
            }, function () {
                if (_this.props.onRequestClose) {
                    _this.props.onRequestClose();
                }
            });
        };
        _this.onSwitchStart = function (newAccount) {
            _this.setState({
                active: false
            }, function () {
                if (_this.props.onSwitchStart) {
                    _this.props.onSwitchStart(newAccount);
                }
            });
        };
        _this.state = {
            active: false
        };
        return _this;
    }
    ManagedAccountSwitch.prototype.render = function () {
        var active = this.state.active;
        return (React.createElement(AccountSwitch_1.AccountSwitch, tslib_1.__assign({}, this.props, { active: active, onClick: this.onClick, onRequestClose: this.onRequestClose, onSwitchStart: this.onSwitchStart })));
    };
    ManagedAccountSwitch.propTypes = objectWithout_1.objectWithout(AccountSwitch_1.AccountSwitch.propTypes, ["active"]);
    return ManagedAccountSwitch;
}(React.Component));
exports.ManagedAccountSwitch = ManagedAccountSwitch;